var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{attrs:{"id":"app"}},[_c('div',{staticClass:"bg-img"},[_c('div',{staticClass:"transbox"},[_c('div',{staticClass:"container-fluid px-0"},[_c('router-view')],1)])])])
}
var staticRenderFns = []

export { render, staticRenderFns }